export default class Sorting {

	public static getDefaultSorts(): Map<string, Sort> {

		const map = new Map<string, Sort>()

		map.set('AspectOutcome', {
			field: 'expansionOrder',
			ascending: true,
		})

		map.set('DifficultyOutcome', {
			field: 'difficulty',
			ascending: true,
		})

		map.set('IslandState', {
			field: 'section',
			ascending: true,
		})

		map.set('LayoutOutcome', {
			field: 'layout',
			ascending: true,
		})

		map.set('LocationOutcome', {
			field: 'playCount',
			ascending: false,
		})

		map.set('OutcomeType', {
			field: 'section',
			ascending: true,
		})

		map.set('SpiritCountOutcome', {
			field: 'spiritCount',
			ascending: true,
		})

		map.set('SpiritOutcome', {
			field: 'setOrder',
			ascending: true,
		})

		map.set('TurnOutcome', {
			field: 'turnCount',
			ascending: true,
		})

		return map
	}

	public static sort(data: Array<any>, sort: Sort, ...tieBreakerFields: string[]): void {
		data.sort((a, b) => {
			return this.compare(a, b, sort.field, sort.ascending, tieBreakerFields)
		})
	}

	private static compare(a: any, b: any, field: string, ascending: boolean, tieBreakerFields?: string[]): number {

		const fieldA = (a as any)[field]
		const fieldB = (b as any)[field]

		const missingA = fieldA === null || fieldA === undefined
		const missingB = fieldB === null || fieldB === undefined

		// Missing values always go to the bottom
		if (!missingA && missingB) {
			return -1
		}
		if (missingA && !missingB) {
			return 1
		}

		if (fieldA > fieldB) {
			return ascending ? 1 : -1
		}
		if (fieldA < fieldB) {
			return ascending ? -1 : 1
		}

		if (tieBreakerFields && tieBreakerFields.length) {
			return this.compare(a, b, tieBreakerFields[0], true, tieBreakerFields.slice(1))
		} else {
			return 0
		}
	}
}

export interface Sort {
	field: string
	ascending: boolean
}
